import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

/**
 * Shape of a single Jira work type (issue type) used by the Playbooks list.
 * Mirrors the shape rendered by the Playbooks edit screen
 * (`PlaybookFilterIssueType`).
 */
export type WorkTypeRest = {
	id: string;
	name: string;
	iconUrl: string;
};

type ProjectResponse = {
	issueTypes?: WorkTypeRest[];
};

export const playbooksListWorkTypesResource: RouteResource<WorkTypeRest[]> = createResource<
	Array<WorkTypeRest>
>({
	type: 'PLAYBOOKS-LIST-WORK-TYPES-RESOURCE-TYPE',
	getKey: ({ match }) => {
		const projectKey = match.params.projectKey;
		return `playbooksListWorkTypesResource-${projectKey}`;
	},
	getData: async ({ match }) => {
		const projectKey = match.params.projectKey ?? '';
		const response = await performGetRequest<ProjectResponse>(getProjectUrl(projectKey));
		return response.issueTypes ?? [];
	},
	maxAge: 5 * 60 * 1000, // 5 minutes
});

const getProjectUrl = (projectKey: string) => `/rest/api/2/project/${projectKey}`;
